import { render } from "./NotePage.vue?vue&type=template&id=c7050618&scoped=true"
import script from "./NotePage.vue?vue&type=script&lang=js"
export * from "./NotePage.vue?vue&type=script&lang=js"

import "./NotePage.vue?vue&type=style&index=0&id=c7050618&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7050618"]])

export default __exports__